function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1a1a;}.cls-2{fill:#f16224;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M91.165,53.5242H12.5645c-4.6714,0-8.4581,3.3588-8.4581,7.5021v39.1753c0,4.1435,3.7867,7.5023,8.4581,7.5023H91.165c4.6713,0,8.4581-3.3588,8.4581-7.5023V61.0263C99.6231,56.883,95.8363,53.5242,91.165,53.5242ZM30.5942,71.164a26.7765,26.7765,0,0,0-4.8786,5.989,32.8315,32.8315,0,0,0-3.7673,8.2739,29.3949,29.3949,0,0,0-1.2906,7.8291H15.2468a29.823,29.823,0,0,1,2.506-10.9249,33.2959,33.2959,0,0,1,6.3186-9.9443H11.33v-4.816H30.5942Zm8.0266,27.7106h-3.612V61.9522h3.612Zm31.3038,0h-3.612V61.9522h3.612ZM93.2018,71.164a26.4448,26.4448,0,0,0-4.881,5.949,33.0747,33.0747,0,0,0-3.7743,8.3139A29.379,29.379,0,0,0,83.26,93.256H77.8493a29.8391,29.8391,0,0,1,2.506-10.9249,33.3038,33.3038,0,0,1,6.3186-9.9443H73.9379v-4.816H93.2018Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M113.7563,73.1894h-1.692V27.73a5.8319,5.8319,0,0,0,2.9528-4.908,5.5564,5.5564,0,0,0-11.1126,0,5.8227,5.8227,0,0,0,2.9425,4.908v45.46h-3.2106V88.0387h10.12c2.04,0,7.1373-1.8922,7.1373-3.9314V76.7222C120.8936,74.6835,115.7959,73.1894,113.7563,73.1894Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M62.8519,76.7563c0-5.7106-10.34-6.3323-10.34,1.5676,0-7.9-10.34-7.2782-10.34-1.5676s6.9363,11.3055,10.34,16.0983C55.83,88.021,62.8519,82.4671,62.8519,76.7563Z"
});

const SvgCasino3 = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125 125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCasino3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/casino3.ef7bb4a2.svg";
export { ForwardRef as ReactComponent };